type TokenListener = () => void;

class TokenManager {
    private token: string | null = null;
    private listeners = new Set<TokenListener>();

    constructor() {
        this.token = localStorage.getItem("token") ?? null;
    }

    public get = () => {
        return this.token === "" ? null : this.token;
    };

    public set = (newToken: string | null) => {
        this.token = newToken;
        localStorage.setItem("token", newToken ?? "");
        this.listeners.forEach((listener) => listener());
    };

    public subscribe = (listener: TokenListener) => {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    };
}

export const tokenManager = new TokenManager();
